import { render, staticRenderFns } from "./GroupItemsPerMonth.vue?vue&type=template&id=5f376212&scoped=true"
import script from "./GroupItemsPerMonth.vue?vue&type=script&lang=js"
export * from "./GroupItemsPerMonth.vue?vue&type=script&lang=js"
import style0 from "./GroupItemsPerMonth.vue?vue&type=style&index=0&id=5f376212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f376212",
  null
  
)

export default component.exports